import { create } from "zustand";

type User = {
  name: string;
  email: string;
};

export type SessionState = {
  sessionId: string;
  token: string;
  connected: boolean;
  lastResponseAt?: string;
  webhookVariant: "default" | "test";
  toolName: string;
  setSession: (sessionId: string, token: string) => void;
  setConnected: (connected: boolean) => void;
  setLastResponse: (timestamp: string) => void;
  setWebhookVariant: (variant: "default" | "test") => void;
  setToolName: (toolName: string) => void;
  reset: () => void;
};

const useSessionStore = create<SessionState>((set) => ({
  sessionId: "",
  token: "",
  connected: false,
  lastResponseAt: undefined,
  webhookVariant: "default",
  toolName: "agent",
  setSession: (sessionId, token) => set({ sessionId, token }),
  setConnected: (connected) => set({ connected }),
  setLastResponse: (timestamp) => set({ lastResponseAt: timestamp }),
  setWebhookVariant: (variant) => set({ webhookVariant: variant }),
  setToolName: (toolName) => set({ toolName }),
  reset: () =>
    set({
      sessionId: "",
      token: "",
      connected: false,
      lastResponseAt: undefined,
      webhookVariant: "default",
      toolName: "agent",
    }),
}));

export default useSessionStore;

